import { TnxLoadEventType } from './tnx-load-event-type.model';
import * as moment from 'moment';
import { Moment } from 'moment';
import { Carrier } from '../../user-dashboard/shared/carrier.model';
import { ExecutionStatus } from './execution-status';
import { TnxErrorContext } from './tnx-error-context';

export class TnxLoadEvent {
  type: TnxLoadEventType;
  happenedAt: Moment;
  acknowledgedAt: Moment;
  computedStatus: ExecutionStatus;
  operationStatus: ExecutionStatus;
  acknowledgementOperationStatus: ExecutionStatus;
  inputPayload: string;
  outputPayload: string;
  errorMessage: string;
  awardedCarrier: Carrier;
  errorContext: TnxErrorContext;

  public static fromDto(p: any) {
    if (!p) {
      return null;
    }

    const event = new TnxLoadEvent();

    event.type = p.event_type;
    event.happenedAt = p.happened_at ? moment(p.happened_at) : null;
    event.acknowledgedAt = p.acknowledged_at ? moment(p.acknowledged_at) : null;
    event.operationStatus = p.operation_status;
    event.acknowledgementOperationStatus = p.acknowledgement_operation_status;
    event.inputPayload = p.input_payload;
    event.outputPayload = p.output_payload;
    event.errorMessage = p.error_message;
    event.awardedCarrier = Carrier.fromDto(p.awarded_carrier);
    event.errorContext = p.error_context == null ? event.getErrorMessageFromOutputPayload() : p.error_context;

    event.computedStatus = event.acknowledgementOperationStatus && event.acknowledgementOperationStatus === ExecutionStatus.FAILED
      ? event.acknowledgementOperationStatus
      : event.operationStatus;

    return event;
  }

  public static fromDtos(p: any[]) {
    return p.map(value => this.fromDto(value));
  }

  public getErrorMessageFromOutputPayload(): string {
    if (!this.outputPayload) {
      return undefined;
    }
    try {
      const parsedOutputPayload = JSON.parse(this.outputPayload);
      if (!parsedOutputPayload.completedSuccessfully && parsedOutputPayload.error && parsedOutputPayload.error.length > 0) {
        return parsedOutputPayload.error[0].userMessage;
      }
    } catch (e) {
      console.error('Error when parsing output payload:', e);
    }
    return undefined;
  }

}
